<template>
  <!-- 会员等级 -->
  <a-layout-content>
    <div v-if="role281">
      <a-button type="primary" @click="add()">添加等级</a-button>
    </div>
    <br />
    <a-table size="middle" :columns="columns" row-key="ID" :data-source="data" :pagination="false" :scroll="{ y: 800 }"
      bordered>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="edit(record)" v-if="role282">
          <a-icon type="edit" style="font-size: 22px"></a-icon>
        </a>
        &nbsp;
        <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)" v-if="role283">
          <a href="javascript:;">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-popconfirm>
      </template>
    </a-table>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" :title="modaltype === 0 ? '新增等级' : '编辑等级'" @ok="handleOk">
      <a-form-model ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="等级名称" ref="Vip" prop="Vip">
          <a-input v-model.number="form.Vip" placeholder="等级名称" />
        </a-form-model-item>
        <a-form-model-item label="累积投注量" ref="Upamt" prop="Upamt">
          <a-input v-model.number="form.Upamt" placeholder="晋级标准(累积投注量)" />
        </a-form-model-item>
        <a-form-model-item label="晋级礼金" ref="Upbonus" prop="Upbonus">
          <a-input v-model.number="form.Upbonus" placeholder="向上晋级获得的礼金奖励" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
  import { isNumber } from "../../js/textverify";
  import _ from 'lodash';

  export default {
    data() {
      return {
        /*** 权限
          281	会员等级新增/编辑
          282	会员等级查询
          283	会员等级删除
         */
        role281: false,
        role282: false,
        role283: false,
        visible: false,
        modaltype: 0, //0:新增 1:编辑
        data: [],
        columns: [
          {
            title: "编号",
            dataIndex: "ID",
            align: "center",
          },
          {
            title: "VIP等级",
            dataIndex: "Vip",
            align: "center",
          },
          {
            title: "晋级标准(累积存款)",
            dataIndex: "Upamt",
            align: "center",
          },
          {
            title: "晋级礼金",
            dataIndex: "Upbonus",
            align: "center",
          },
          {
            title: "操作",
            dataIndex: "operation",
            width: "200px",
            align: "center",
            scopedSlots: { customRender: "operation" },
          },
        ],
        form: {},
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        rules: {
          Vip: [
            { required: true, message: '请输入等级名称', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
          Upamt: [
            { required: true, message: '请输入投注量', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
          Upbonus: [
            { required: true, message: '请输入普级礼金', trigger: 'blur' },
            { validator: isNumber, trigger: 'change' },
          ],
        }
      };
    },
    methods: {
      onDelete(val) {
        this.axios.post("/rank/deleteuserrank", { id: val.ID }).then((res) => {
          if (res.data) {
            this.$message.success("删除成功");
            this.qryListAPI();
          }
        });
      },
      add() {
        this.modaltype = 0;
        this.form = {};
        this.form.ID = 0;
        this.form.Type = 4;
        this.visible = true;
      },
      edit(val) {
        this.modaltype = 1;
        this.form = _.cloneDeep(val);
        this.visible = true;
      },
      //对话框确认按钮
      handleOk() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.axios.post("/rank/setuserrank", this.form).then((res) => {
              if (res.data == "0") {
                const mes = this.modaltype === 0 ? "添加成功" : "编辑成功";
                this.$message.success(mes);
                this.qryListAPI();
                this.visible = false;
              }
              else if (res.data == "-1") {
                this.$message.error("不允许存在重复等级！");
                this.qryListAPI();
                this.visible = false;
              }
            });
          }
        });
      },
      // 查询API
      qryListAPI() {
        this.axios.post("/rank/getuserrank", { Type: 4 }).then((res) => {
          if (res.data) {
            this.data = res.data;
          }
        });
      },
    },
    //首次加载
    created() {
      this.qryListAPI();
      //获取权限
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [281, 282, 283];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1
      });
      //功能权限获取
      isRole.forEach(element => {
        this["role" + element] = true;
      });
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/vipleaderboard/viprankuservip.vue